import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-textile-model-category7s',
  templateUrl: './textile-model-category7s.component.html',
  styleUrls: ['./textile-model-category7s.component.css']
})
export class TextileModelCategory7sComponent implements OnInit {
    public itemsListCategories7: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadCategory7s(): Promise<void> {
        this.itemsListCategories7 = await this.datatask.Post(2696);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'textilemodelcategory7':
                this.stateService?.go('textilemodelcategory7', { textilemodelcategory7_keyno: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadCategory7s();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('textileModelCategory7s', {
//        templateUrl: 'views/components/views/textileModelCategory7s/textileModelCategory7s.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'textileModelCategory7sService', function (stateService, textileModelCategory7sService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListCategories7: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadTextileModelCategory7s() {
//                vm.model.itemsListCategories7 = await textileModelCategory7sService.listTextileModelCategory7s();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'textilemodelcategory7':
//                        go({ textilemodelcategory7_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadTextileModelCategory7s();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
